import { i18n } from 'yxt-biz-pc/packages/common-util/changeLangs';

// 0考勤,1面授,2考试,3调查,4评价,5投票,6作业,7活动,8知识文档,9课程包,10知识微课,11知识视频,12知识音频,13知识scorm,14其他任务,15任务组, 16Html 17直播 18知识（大类型） 19练习
export const getTaskType = type => {
  switch (type) {
    case 0:
      return i18n.t('pc_biz_o2o_lbl_sign');
    case 1:
      return i18n.t('pc_biz_o2o_lbl_facetoface');
    case 2:
      return i18n.t('pc_biz_o2o_lbl_exam');
    case 3:
      return i18n.t('pc_biz_o2o_lbl_survey');
    case 4:
      return i18n.t('pc_biz_o2o_lbl_evaluation');
    case 5:
      return i18n.t('pc_biz_o2o_lbl_vote');
    case 6:
      return i18n.t('pc_biz_o2o_lbl_homework');
    case 7:
      return i18n.t('pc_biz_o2o_lbl_activity');
    case 8:
      return i18n.t('pc_biz_o2o_lbl_doc');
    case 9:
      return i18n.t('pc_biz_o2o_lbl_course');
    case 10:
      return i18n.t('pc_biz_o2o_lbl_weike');
    case 11:
      return i18n.t('pc_biz_o2o_task_videoName');
    case 12:
      return i18n.t('pc_biz_o2o_lbl_audio');
    case 13:
      return 'Scorm';
    case 14:
      return i18n.t('pc_biz_o2o_lbl_outerlink');
    case 16:
      return 'html';
    case 17:
      return i18n.t('pc_biz_o2o_lbl_live');
    case 19:
      return i18n.t('pc_biz_o2o_lbl_practice');
  }
};
